import _ from 'underscore';
import {
  UAPImageType,
  UAPPlacementType as PT,
  UAPVideoType,
} from '../@types';
import type {
  UAPImageTypeValue,
  UAPPlacementMeta,
  UAPPlacementTypeValue,
} from '../@types';

export const UAPLPlacementMetaList: Record<string, UAPPlacementMeta> = {
  [PT.MMA_WideImage_4x1]: {
    placementType: PT.MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    // used to compare ratio values, use string instead of number to avoid precision issue
    aspectRatioStr: '4:1', // refer to: private\ad-creator-tools\packages\media-common-utils\src\aspect-ratio-config.js
    previewHeight: 152,
    minSize: [608, 152],
  },
  [PT.MMA_LandscapeImage_191x100]: {
    placementType: PT.MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
    ignoreImageFitting: true,
  },
  [PT.MMA_SquareImage_1x1]: {
    placementType: PT.MMA_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 400,
    minSize: [470, 470],
    ignoreImageFitting: true,
  },
  [PT.MMA_VerticalImage_1x2]: {
    placementType: PT.MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },

  // MMA in MSAN
  [PT.Audience_Network_WideImage_191x100]: {
    placementType: PT.Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.MSN_InArticle_Ad_150x100]: {
    placementType: PT.MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.MSN_Small_Headline_133x100]: {
    placementType: PT.MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.Audience_Network_SquareImage_1x1]: {
    placementType: PT.Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },

  // pmax
  [PT.PMax_MMA_LandscapeImage_191x100]: {
    placementType: PT.PMax_MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMA_WideImage_4x1]: {
    placementType: PT.PMax_MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    aspectRatioStr: '4:1',
    previewHeight: 152,
    minSize: [608, 152],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMA_VerticalImage_1x2]: {
    placementType: PT.PMax_MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
    ignoreImageFitting: true,
  },
  [PT.PMax_Audience_Network_SquareImage_1x1]: {
    placementType: PT.PMax_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
    ignoreImageFitting: true,
  },
  [PT.PMax_Audience_Network_WideImage_191x100]: {
    placementType: PT.PMax_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
    ignoreImageFitting: true,
  },
  [PT.PMax_MSN_InArticle_Ad_150x100]: {
    placementType: PT.PMax_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
    ignoreImageFitting: true,
  },
  [PT.PMax_MSN_Small_Headline_133x100]: {
    placementType: PT.PMax_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
    ignoreImageFitting: true,
  },
  [PT.PMax_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.PMax_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100]: {
    placementType: PT.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMAV2_MSN_Single_Carousel_169x100]: {
    placementType: PT.PMax_MMAV2_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMAV2_MSN_Restoday_124x100]: {
    placementType: PT.PMax_MMAV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMAV2_MSN_River_191x100]: {
    placementType: PT.PMax_MMAV2_MSN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
    ignoreImageFitting: true,
  },

  //
  // MMA in MSAN V2
  [PT.MsanV2_Microsoft_Edge_Carouse_l201x100]: {
    placementType: PT.MsanV2_Microsoft_Edge_Carouse_l201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
  },
  [PT.MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 90,
    minSize: [200, 100],
  },
  [PT.MsanV2_MSAN_River_191x100]: {
    placementType: PT.MsanV2_MSAN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },
  [PT.MsanV2_MSN_Carousel_169x100]: {
    placementType: PT.MsanV2_MSN_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
  },
  [PT.MsanV2_MSN_Restoday_124x100]: {
    placementType: PT.MsanV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.MsanV2_MSAN_Rectangle_120x100]: {
    placementType: PT.MsanV2_MSAN_Rectangle_120x100,
    imageType: UAPImageType.Image120x100,
    aspectRatio: 1.2,
    aspectRatioStr: '120:100',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [114, 114],
  },
  [PT.PMax_Video]: {
    placementType: PT.PMax_Video,
    imageType: UAPVideoType.VideoMedia16X9,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },

  // UC video placements (distinct types per slot to prevent deduplication)
  [PT.UC_Video_MSNWatch]: {
    placementType: PT.UC_Video_MSNWatch,

    imageType: UAPVideoType.VideoMSNWatch,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.UC_Video_MSNPlay]: {
    placementType: PT.UC_Video_MSNPlay,

    imageType: UAPVideoType.VideoMSNPlay,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  // MSN Computer + Smartphone share the desktop XANDR (16:9) template
  [PT.UC_Video_MSNComputer]: {
    placementType: PT.UC_Video_MSNComputer,

    imageType: UAPVideoType.VideoMSNComputer,
    aspectRatio: 1.787,
    aspectRatioStr: '16:9',
    previewHeight: 286,
    minSize: [640, 360],
  },
  [PT.UC_Video_MSNSmartphone]: {
    placementType: PT.UC_Video_MSNSmartphone,

    imageType: UAPVideoType.VideoMSNSmartphone,
    aspectRatio: 1.787,
    aspectRatioStr: '16:9',
    previewHeight: 286,
    minSize: [640, 360],
  },

  // UC video device-style placements (CTV + Gaming): 16:9 inline + landscape, 9:16 portrait
  [PT.UC_Video_Inline]: {
    placementType: PT.UC_Video_Inline,

    imageType: UAPVideoType.VideoUCInline,
    aspectRatio: 1.78,
    aspectRatioStr: '16:9',
    previewHeight: 200,
    minSize: [640, 360],
  },
  [PT.UC_Video_MobileLandscape]: {
    placementType: PT.UC_Video_MobileLandscape,

    imageType: UAPVideoType.VideoUCMobileLandscape,
    aspectRatio: 1.78,
    aspectRatioStr: '16:9',
    previewHeight: 200,
    minSize: [640, 360],
  },
  [PT.UC_Video_MobilePortrait]: {
    placementType: PT.UC_Video_MobilePortrait,

    imageType: UAPVideoType.VideoUCMobilePortrait,
    aspectRatio: 0.5625,
    aspectRatioStr: '9:16',
    previewHeight: 360,
    minSize: [360, 640],
  },

  // UC video Video-partners slot: a single plain 16:9 ClipchampPlayer (no template)
  [PT.UC_Video_VideoPartners]: {
    placementType: PT.UC_Video_VideoPartners,

    imageType: UAPVideoType.VideoUCVideoPartners,
    aspectRatio: 1.78,
    aspectRatioStr: '16:9',
    previewHeight: 200,
    minSize: [640, 360],
  },

  // UC display placements (rendered by UCDisplayPlacement; no image fitting needed)
  [PT.UC_Display_320x50]: {
    placementType: PT.UC_Display_320x50,
    imageType: 'DisplaySmallLeaderboard',
    aspectRatio: 6.4,
    aspectRatioStr: '320:50',
    previewHeight: 50,
    minSize: [320, 50],
  },
  [PT.UC_Display_320x100]: {
    placementType: PT.UC_Display_320x100,
    imageType: 'DisplayLargeMobileBanner',
    aspectRatio: 3.2,
    aspectRatioStr: '320:100',
    previewHeight: 100,
    minSize: [320, 100],
  },
  [PT.UC_Display_300x250]: {
    placementType: PT.UC_Display_300x250,
    imageType: 'DisplayMediumRectangle',
    aspectRatio: 1.2,
    aspectRatioStr: '300:250',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.UC_Display_300x600]: {
    placementType: PT.UC_Display_300x600,
    imageType: 'DisplayHalfPage',
    aspectRatio: 0.5,
    aspectRatioStr: '300:600',
    previewHeight: 300,
    minSize: [300, 600],
  },
  [PT.UC_Display_160x600]: {
    placementType: PT.UC_Display_160x600,
    imageType: 'DisplayWideSkyscraper',
    aspectRatio: 0.267,
    aspectRatioStr: '160:600',
    previewHeight: 300,
    minSize: [160, 600],
  },
  [PT.UC_Display_970x250]: {
    placementType: PT.UC_Display_970x250,
    imageType: 'DisplayBillboard',
    aspectRatio: 3.88,
    aspectRatioStr: '970:250',
    previewHeight: 100,
    minSize: [970, 250],
  },
  [PT.UC_Display_728x90]: {
    placementType: PT.UC_Display_728x90,
    imageType: 'DisplayLeaderboard',
    aspectRatio: 8.089,
    aspectRatioStr: '728:90',
    previewHeight: 90,
    minSize: [728, 90],
  },
  [PT.UC_Display_336x280]: {
    placementType: PT.UC_Display_336x280,
    imageType: 'DisplayLargeRectangle',
    aspectRatio: 1.2,
    aspectRatioStr: '336:280',
    previewHeight: 280,
    minSize: [336, 280],
  },
  [PT.UC_Display_970x90]: {
    placementType: PT.UC_Display_970x90,
    imageType: 'DisplaySuperLeaderboard',
    aspectRatio: 10.778,
    aspectRatioStr: '970:90',
    previewHeight: 90,
    minSize: [970, 90],
  },
  [PT.UC_Display_468x60]: {
    placementType: PT.UC_Display_468x60,
    imageType: 'DisplayFullBanner',
    aspectRatio: 7.8,
    aspectRatioStr: '468:60',
    previewHeight: 60,
    minSize: [468, 60],
  },
  [PT.UC_Display_300x50]: {
    placementType: PT.UC_Display_300x50,
    imageType: 'DisplayBanner',
    aspectRatio: 6,
    aspectRatioStr: '300:50',
    previewHeight: 50,
    minSize: [300, 50],
  },
  [PT.UC_Display_216x36]: {
    placementType: PT.UC_Display_216x36,
    imageType: 'DisplayLargeBanner',
    aspectRatio: 6,
    aspectRatioStr: '216:36',
    previewHeight: 36,
    minSize: [216, 36],
  },
  [PT.UC_Display_168x28]: {
    placementType: PT.UC_Display_168x28,
    imageType: 'DisplayMediumBanner',
    aspectRatio: 6,
    aspectRatioStr: '168:28',
    previewHeight: 28,
    minSize: [168, 28],
  },
  [PT.UC_Display_120x20]: {
    placementType: PT.UC_Display_120x20,
    imageType: 'DisplaySmallBanner',
    aspectRatio: 6,
    aspectRatioStr: '120:20',
    previewHeight: 20,
    minSize: [120, 20],
  },
  [PT.UC_Display_234x60]: {
    placementType: PT.UC_Display_234x60,
    imageType: 'DisplayHalfBanner',
    aspectRatio: 3.9,
    aspectRatioStr: '234:60',
    previewHeight: 60,
    minSize: [234, 60],
  },
  [PT.UC_Display_480x320]: {
    placementType: PT.UC_Display_480x320,
    imageType: 'DisplayLandscape',
    aspectRatio: 1.5,
    aspectRatioStr: '480:320',
    previewHeight: 300,
    minSize: [480, 320],
  },
  [PT.UC_Display_180x150]: {
    placementType: PT.UC_Display_180x150,
    imageType: 'DisplayRectangle',
    aspectRatio: 1.2,
    aspectRatioStr: '180:150',
    previewHeight: 150,
    minSize: [180, 150],
  },
  [PT.UC_Display_250x250]: {
    placementType: PT.UC_Display_250x250,
    imageType: 'DisplaySquare',
    aspectRatio: 1,
    aspectRatioStr: '250:250',
    previewHeight: 250,
    minSize: [250, 250],
  },
  [PT.UC_Display_320x480]: {
    placementType: PT.UC_Display_320x480,
    imageType: 'DisplayPortrait',
    aspectRatio: 0.667,
    aspectRatioStr: '320:480',
    previewHeight: 300,
    minSize: [320, 480],
  },
  [PT.UC_Display_120x600]: {
    placementType: PT.UC_Display_120x600,
    imageType: 'DisplaySkyscraper',
    aspectRatio: 0.2,
    aspectRatioStr: '120:600',
    previewHeight: 300,
    minSize: [120, 600],
  },
  [PT.UC_Display_Selected]: {
    placementType: PT.UC_Display_Selected,
    imageType: 'DisplaySelected',
    aspectRatio: 1.2,
    aspectRatioStr: '1:1',
    previewHeight: 250,
    minSize: [300, 250],
  },

  //
  // Boost
  [PT.Boost_Hero_Image_Carousel_200x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_200x100,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 320,
    minSize: [200, 100],
  },
  [PT.Boost_Hero_Image_Carousel_122x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_122x100,
    imageType: UAPImageType.Image122x100,
    aspectRatio: 1.225,
    aspectRatioStr: '122:100',
    previewHeight: 320,
    minSize: [450, 368],
  },
  [PT.Boost_Hero_Image_Carousel_159x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_159x100,
    imageType: UAPImageType.Image159x100,
    aspectRatio: 1.59,
    aspectRatioStr: '159:100',
    previewHeight: 320,
    minSize: [585, 368],
  },
  [PT.Boost_Hero_Image_Carousel_180x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_180x100,
    imageType: UAPImageType.Image180x100,
    aspectRatio: 1.805,
    aspectRatioStr: '180:100',
    previewHeight: 320,
    minSize: [664, 368],
  },
  [PT.Boost_Hero_Image_Carousel_233x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_233x100,
    imageType: UAPImageType.Image233x100,
    aspectRatio: 2.33,
    aspectRatioStr: '233:100',
    previewHeight: 250,
    minSize: [703, 301],
  },
  [PT.Boost_Hero_Image_Carousel_320x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_320x100,
    imageType: UAPImageType.Image320x100,
    aspectRatio: 3.20,
    aspectRatioStr: '320:100',
    previewHeight: 180,
    minSize: [703, 219],
  },
  [PT.Boost_Hero_Image_Carousel_57x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_57x100,
    imageType: UAPImageType.Image57x100,
    aspectRatio: 0.57,
    aspectRatioStr: '57:100',
    previewHeight: 320,
    minSize: [210, 368],
  },
  [PT.Boost_Windows_Spotlight_191x100]: {
    placementType: PT.Boost_Windows_Spotlight_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.9,
    aspectRatioStr: '190:100',
    previewHeight: 400,
    minSize: [268, 140],
  },
  [PT.Boost_Discover_Card_1x1]: {
    placementType: PT.Boost_Discover_Card_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 250,
    minSize: [300, 300],
  },
  [PT.Boost_Start_Menu]: {
    placementType: PT.Boost_Start_Menu,
  },
  [PT.Boost_Action_Center]: {
    placementType: PT.Boost_Action_Center,
    logoHeight: 48,
  },
  [PT.Boost_Banner]: {
    placementType: PT.Boost_Banner,
    logoHeight: 20,
  },
  [PT.Boost_Prong1_Prong2_Feed_191x100]: {
    placementType: PT.Boost_Prong1_Prong2_Feed_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.914,
    aspectRatioStr: '191:100',
    previewHeight: 140,
    minSize: [268, 140],
  },
  [PT.Boost_Coachmark_175x100]: {
    placementType: PT.Boost_Coachmark_175x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.75,
    aspectRatioStr: '178:100',
    previewHeight: 160,
    minSize: [280, 160],
  },

  //
  // image extension
  [PT.ImgExt_Audience_Network_WideImage_191x100]: {
    placementType: PT.ImgExt_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.ImgExt_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.ImgExt_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.ImgExt_Bing_Desktop_SingleImage_Extension_178x100]: {
    placementType: PT.ImgExt_Bing_Desktop_SingleImage_Extension_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 45,
    minSize: [624, 350],
    ignoreImageFitting: true,
  },
  [PT.ImgExt_Microsoft_Edge_Medium_Headline_172x100]: {
    placementType: PT.ImgExt_Microsoft_Edge_Medium_Headline_172x100,
    imageType: UAPImageType.Image172x100,
    aspectRatio: 1.72,
    aspectRatioStr: '172:100',
    previewHeight: 174,
    minSize: [300, 174],
  },
  [PT.ImgExt_MSN_Single_Carousel_169x100]: {
    placementType: PT.ImgExt_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 368,
    minSize: [622, 368],
  },
  [PT.ImgExt_MSN_Medium_Headline_155x100]: {
    placementType: PT.ImgExt_MSN_Medium_Headline_155x100,
    imageType: UAPImageType.Image155x100,
    aspectRatio: 1.55,
    aspectRatioStr: '155:100',
    previewHeight: 194,
    minSize: [300, 194],
  },
  [PT.ImgExt_MSN_InArticle_Ad_150x100]: {
    placementType: PT.ImgExt_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.50,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.ImgExt_MSN_Small_Headline_133x100]: {
    placementType: PT.ImgExt_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.ImgExt_Bing_Desktop_MultiImage_Extension_133x100]: {
    placementType: PT.ImgExt_Bing_Desktop_MultiImage_Extension_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 100,
    minSize: [100, 75],
    hasMultiImages: true,
    ignoreImageFitting: true,
  },
  [PT.ImgExt_Bing_Mobile_MultiImage_Extension_133x100]: {
    placementType: PT.ImgExt_Bing_Mobile_MultiImage_Extension_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 310,
    minSize: [100, 75],
    hasMultiImages: true,
    ignoreImageFitting: true,
  },
  [PT.ImgExt_Audience_Network_SquareImage_1x1]: {
    placementType: PT.ImgExt_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },
  [PT.ImgExt_MSN_Double_Carousel_93x100]: {
    placementType: PT.ImgExt_MSN_Double_Carousel_93x100,
    imageType: UAPImageType.Image93x100,
    aspectRatio: 0.93,
    aspectRatioStr: '93:100',
    previewHeight: 333,
    minSize: [311, 333],
    ignoreImageFitting: true,
  },
  [PT.ImgExt_MMAV2_MSN_River_191x100]: {
    placementType: PT.ImgExt_MMAV2_MSN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },
  [PT.ImgExt_MMAV2_MSN_Single_Carousel_169x100]: {
    placementType: PT.ImgExt_MMAV2_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },

  // text ads
  [PT.Outlook_Text_Mobile]: {
    placementType: PT.Outlook_Text_Mobile,
    logoHeight: 32,
  },
  [PT.Outlook_Text_Web]: {
    placementType: PT.Outlook_Text_Web,
    logoHeight: 28,
  },
  [PT.Bing_Search_Mobile]: {
    placementType: PT.Bing_Search_Mobile,
  },
  [PT.Bing_Search_Desktop]: {
    placementType: PT.Bing_Search_Desktop,
  },
  [PT.Bing_Search_Text]: {
    placementType: PT.Bing_Search_Text,
    logoHeight: 37,
  },

  [PT.Responsive_MMA_WideImage_4x1]: {
    placementType: PT.Responsive_MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    // used to compare ratio values, use string instead of number to avoid precision issue
    aspectRatioStr: '4:1', // refer to: private\ad-creator-tools\packages\media-common-utils\src\aspect-ratio-config.js
    previewHeight: 152,
    minSize: [608, 152],
  },
  [PT.Responsive_MMA_LandscapeImage_191x100]: {
    placementType: PT.Responsive_MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
  },
  [PT.Responsive_MMA_SquareImage_1x1]: {
    placementType: PT.Responsive_MMA_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 400,
    minSize: [470, 470],
  },
  [PT.Responsive_MMA_VerticalImage_1x2]: {
    placementType: PT.Responsive_MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },

  // MMA in MSAN
  [PT.Responsive_Audience_Network_WideImage_191x100]: {
    placementType: PT.Responsive_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.Responsive_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.Responsive_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.Responsive_MSN_InArticle_Ad_150x100]: {
    placementType: PT.Responsive_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.Responsive_MSN_Small_Headline_133x100]: {
    placementType: PT.Responsive_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.Responsive_Audience_Network_SquareImage_1x1]: {
    placementType: PT.Responsive_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },

  // Responsive MMA in MSAN V2
  [PT.Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100]: {
    placementType: PT.Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
  },
  [PT.Responsive_MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.Responsive_MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 90,
    minSize: [200, 100],
  },
  [PT.Responsive_MsanV2_MSAN_River_191x100]: {
    placementType: PT.Responsive_MsanV2_MSAN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },
  [PT.Responsive_MsanV2_MSN_Carousel_169x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
  },
  [PT.Responsive_MsanV2_MSN_Restoday_124x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.Responsive_MsanV2_MSAN_Rectangle_120x100]: {
    placementType: PT.Responsive_MsanV2_MSAN_Rectangle_120x100,
    imageType: UAPImageType.Image120x100,
    aspectRatio: 1.2,
    aspectRatioStr: '120:100',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [114, 114],
  },

  [PT.Responsive_PMax_MMA_LandscapeImage_191x100]: {
    placementType: PT.Responsive_PMax_MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    logoHeight: 19.4,
    minSize: [703, 368],
  },
  [PT.Responsive_PMax_MMA_WideImage_4x1]: {
    placementType: PT.Responsive_PMax_MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    aspectRatioStr: '4:1',
    previewHeight: 95,
    minSize: [380, 95],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_MMA_VerticalImage_1x2]: {
    placementType: PT.Responsive_PMax_MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_Audience_Network_SquareImage_1x1]: {
    placementType: PT.Responsive_PMax_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },
  [PT.Responsive_PMax_Audience_Network_WideImage_191x100]: {
    placementType: PT.Responsive_PMax_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.Responsive_PMax_MSN_InArticle_Ad_150x100]: {
    placementType: PT.Responsive_PMax_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.Responsive_PMax_MSN_Small_Headline_133x100]: {
    placementType: PT.Responsive_PMax_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },

  [PT.Responsive_Outlook_Text_Mobile]: {
    placementType: PT.Responsive_Outlook_Text_Mobile,
    logoHeight: 24,
  },
  [PT.Responsive_Outlook_Text_Web]: {
    placementType: PT.Responsive_Outlook_Text_Web,
    logoHeight: 24,
  },
  [PT.Responsive_Bing_Search_Text]: {
    placementType: PT.Responsive_Bing_Search_Text,
  },

  [PT.Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100]: {
    placementType: PT.Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 200,
    minSize: [612, 304],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 200,
    minSize: [628, 372],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_MMAV2_MSN_Restoday_124x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_MMAV2_MSN_River_191x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
    ignoreImageFitting: true,
  },

  // responsive boost ads
  [PT.Responsive_Boost_Windows_Spotlight_191x100]: {
    placementType: PT.Responsive_Boost_Windows_Spotlight_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.9,
    aspectRatioStr: '190:100',
    previewHeight: 250, // use a smaller value for responsive version
    minSize: [268, 140],
  },
  [PT.Responsive_Boost_Discover_Card_1x1]: {
    placementType: PT.Responsive_Boost_Discover_Card_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 200,
    minSize: [300, 300],
  },
  [PT.Responsive_Boost_Start_Menu]: {
    placementType: PT.Responsive_Boost_Start_Menu,
  },
  [PT.Responsive_Boost_Action_Center]: {
    placementType: PT.Responsive_Boost_Action_Center,
    logoHeight: 48,
  },
  [PT.Responsive_Boost_Banner]: {
    placementType: PT.Responsive_Boost_Banner,
    logoHeight: 20,
  },
  [PT.Responsive_Boost_Prong1_Prong2_Feed_191x100]: {
    placementType: PT.Responsive_Boost_Prong1_Prong2_Feed_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.914,
    aspectRatioStr: '191:100',
    previewHeight: 140,
    logoHeight: 16,
    imageBorderRadius: 8,
    minSize: [268, 140],
  },
  [PT.Responsive_Boost_Coachmark_175x100]: {
    placementType: PT.Responsive_Boost_Coachmark_175x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.75,
    aspectRatioStr: '178:100',
    previewHeight: 160,
    minSize: [280, 160],
  },
  [PT.Responsive_Boost_Mini_Spotlight]: {
    placementType: PT.Responsive_Boost_Mini_Spotlight,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.9,
    aspectRatioStr: '190:100',
    previewHeight: 250, // use a smaller value for responsive version
    minSize: [268, 140],
  },
  [PT.Responsive_Boost_Spotlight_Portrait]: {
    placementType: PT.Responsive_Boost_Spotlight_Portrait,
    imageType: UAPImageType.Image57x100,
    aspectRatio: 0.57,
    aspectRatioStr: '57:100',
    previewHeight: 391,
    minSize: [220, 391],
  },
  [PT.Responsive_Boost_Content_Hub]: {
    placementType: PT.Responsive_Boost_Content_Hub,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 100,
    minSize: [133, 100],
  },
  [PT.Responsive_Boost_Microsoft_Plus]: {
    placementType: PT.Responsive_Boost_Microsoft_Plus,
    imageType: UAPImageType.Image320x100,
    aspectRatio: 3.20,
    aspectRatioStr: '320:100',
    previewHeight: 100,
    minSize: [320, 100],
  },
  // LinkedIn
  [PT.LinkedIn_Single_Image_Desktop_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Desktop_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 180,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 140,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Medium_Rectangle_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Medium_Rectangle_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 153,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Interstitial_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Interstitial_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 99,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Native_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Native_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 144,
    minSize: [640, 360],
  },

  [PT.LinkedIn_Single_Image_Desktop_Square]: {
    placementType: PT.LinkedIn_Single_Image_Desktop_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 348,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Square]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 275,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Medium_Rectangle_Square]: {
    placementType: PT.LinkedIn_Single_Image_Medium_Rectangle_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 275,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Interstitial_Square]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Interstitial_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 188,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Native_Square]: {
    placementType: PT.LinkedIn_Single_Image_Native_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 275,
    minSize: [360, 360],
  },

  [PT.LinkedIn_Single_Image_Mobile_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Vertical,

    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 275,
    minSize: [360, 640],
  },
  [PT.LinkedIn_Single_Image_Medium_Rectangle_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Medium_Rectangle_Vertical,

    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.LinkedIn_Single_Image_Mobile_Interstitial_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Interstitial_Vertical,

    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 150,
    minSize: [360, 640],
  },
  [PT.LinkedIn_Single_Image_Native_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Native_Vertical,

    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.Unified_App_Ads_Video_Horizontal]: {
    placementType: PT.Unified_App_Ads_Video_Horizontal,
    imageType: UAPVideoType.VideoMedia16X9,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.Unified_App_Ads_Bing_Search]: {
    placementType: PT.Unified_App_Ads_Bing_Search,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 100,
    minSize: [100, 75],
  },
  [PT.Unified_App_Ads_Bing_Search_Text]: {
    placementType: PT.Unified_App_Ads_Bing_Search_Text,
  },
  [PT.Unified_App_Ads_Causal_Games_Dimensions]: {
    placementType: PT.Unified_App_Ads_Causal_Games_Dimensions,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 250,
    minSize: [300, 300],
  },
  [PT.Unified_App_Ads_M365_Outlook]: {
    placementType: PT.Unified_App_Ads_M365_Outlook,
  },
  [PT.Unified_App_Ads_MSN_Display]: {
    placementType: PT.Unified_App_Ads_MSN_Display,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 180,
    minSize: [640, 360],
  },

  // universal campaign (UC) — geometry mirrors the MMA/MSANV2 renderers that UC reuses
  // (see get-ad-placement-component.js). Required so getPlacementListMetaData resolves UC placements;
  // without these, building the UC placement set throws on undefined meta and the Edit Image page hangs.
  [PT.UC_SquareImage_1x1]: {
    placementType: PT.UC_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 400,
    minSize: [470, 470],
  },
  [PT.UC_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.UC_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
    ignoreImageFitting: true,
  },
  [PT.UC_MSNRestoday_124x100]: {
    placementType: PT.UC_MSNRestoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.UC_MSNPartnerStripe_153x100]: {
    placementType: PT.UC_MSNPartnerStripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    // Renderer AdPlacementMmaInMsanV2MSNPartnerStripe153x100 uses a fixed 200px-tall image
    // container; previewHeight must be 200 (200 * 1.53 = 306 = card width) to fill it.
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.UC_MSNCarousel_169x100]: {
    placementType: PT.UC_MSNCarousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.UC_MSNFeed_191x100]: {
    placementType: PT.UC_MSNFeed_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    // Renderer AdPlacementMmaInMsanV2MSANRiver191x100 uses a fixed 300x157 image container.
    previewHeight: 157,
    minSize: [300, 157],
    ignoreImageFitting: true,
  },
  [PT.UC_LandscapeImageMMA_191x100]: {
    placementType: PT.UC_LandscapeImageMMA_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
    ignoreImageFitting: true,
  },
  [PT.UC_EdgeCarousel_201x100]: {
    placementType: PT.UC_EdgeCarousel_201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
  },
  [PT.UC_MSNBanner_2x1]: {
    placementType: PT.UC_MSNBanner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    // Renderer AdPlacementMmaInMsanV2MSANBanner2x1 uses a fixed 200x100 image container;
    // previewHeight must be 100 (100 * 2 = 200 = container width) to fill it.
    previewHeight: 100,
    minSize: [200, 100],
  },
  [PT.UC_MSNRectangle_120x100]: {
    placementType: PT.UC_MSNRectangle_120x100,
    imageType: UAPImageType.Image120x100,
    aspectRatio: 1.2,
    aspectRatioStr: '120:100',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.UC_VerticalImage_1x2]: {
    placementType: PT.UC_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },
  [PT.UC_WideImage_4x1]: {
    placementType: PT.UC_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    aspectRatioStr: '4:1',
    previewHeight: 152,
    minSize: [608, 152],
  },
  // TODO: add configs for vertical and square images

  // Universal Campaign INLINE-preview meta — compact twins of the UC_* Edit-page meta above.
  // Same aspect ratio / imageType / minSize, but small previewHeight so the wizard carousel
  // column renders compact (mirrors the PMax responsive inline sizes). Rendered via the reused
  // responsive components registered in get-ad-placement-component.js.
  [PT.Responsive_UC_SquareImage_1x1]: {
    placementType: PT.Responsive_UC_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 400,
    minSize: [470, 470],
  },
  [PT.Responsive_UC_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_UC_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_MSNRestoday_124x100]: {
    placementType: PT.Responsive_UC_MSNRestoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_MSNPartnerStripe_153x100]: {
    placementType: PT.Responsive_UC_MSNPartnerStripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_MSNCarousel_169x100]: {
    placementType: PT.Responsive_UC_MSNCarousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 200,
    minSize: [628, 372],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_MSNFeed_191x100]: {
    placementType: PT.Responsive_UC_MSNFeed_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    // Reuses the river renderer (fixed 300x157 image container), same as the Edit-page UC MSN feed.
    previewHeight: 157,
    minSize: [300, 157],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_LandscapeImageMMA_191x100]: {
    placementType: PT.Responsive_UC_LandscapeImageMMA_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_EdgeCarousel_201x100]: {
    placementType: PT.Responsive_UC_EdgeCarousel_201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 200,
    minSize: [612, 304],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_MSNBanner_2x1]: {
    placementType: PT.Responsive_UC_MSNBanner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    // The inline banner renderer (AdPlacementMmaInMsanV2MSANBanner2x1) uses a fixed 200x100 image
    // container, so previewHeight must be 100 (100 * aspectRatio 2 = 200) to fill it exactly.
    previewHeight: 100,
    minSize: [200, 100],
  },
  [PT.Responsive_UC_MSNRectangle_120x100]: {
    placementType: PT.Responsive_UC_MSNRectangle_120x100,
    imageType: UAPImageType.Image120x100,
    aspectRatio: 1.2,
    aspectRatioStr: '120:100',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.Responsive_UC_VerticalImage_1x2]: {
    placementType: PT.Responsive_UC_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 320,
    minSize: [470, 940],
    ignoreImageFitting: true,
  },
  [PT.Responsive_UC_WideImage_4x1]: {
    placementType: PT.Responsive_UC_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    aspectRatioStr: '4:1',
    previewHeight: 95,
    minSize: [380, 95],
    ignoreImageFitting: true,
  },
};

export const UAPLPlacementMetaListV2: Record<string, UAPPlacementMeta> = {
  ...UAPLPlacementMetaList,
  [PT.MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },
  [PT.MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 100,
    minSize: [200, 100],
  },
  [PT.PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
    ignoreImageFitting: true,
  },
  [PT.PMax_MMAV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
    ignoreImageFitting: true,
  },
  [PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },
  [PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.Responsive_MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.Responsive_MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 100,
    minSize: [200, 100],
  },
  [PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
    ignoreImageFitting: true,
  },
  [PT.Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
    ignoreImageFitting: true,
  },
};


export const getPlacementListMetaData = (placementTypes: UAPPlacementTypeValue[], isAdPreviewRefreshEnabled?: boolean) => {
  const PlacementMetaList = isAdPreviewRefreshEnabled ? UAPLPlacementMetaListV2 : UAPLPlacementMetaList;
  const types = _.compact(placementTypes);

  if (_.isEmpty(types)) {
    return [];
  }
  const ret = _.map(
    types,
    placementType => PlacementMetaList[placementType as keyof typeof PlacementMetaList]
  );
  return ret;
};


export const getPlacementListMetaDataByImageType = (imageTypes: UAPImageTypeValue[]) => {
  const types = _.compact(imageTypes);
  if (_.isEmpty(types)) {
    return [];
  }
  const placementMetaList = Object.values(UAPLPlacementMetaList);
  const ret = _.chain(types)
    .map(imgType => _.filter(placementMetaList, ({ imageType }) => imgType && imageType && (imageType.toLowerCase() === imgType.toLowerCase())))
    .flatten()
    .compact()
    .uniq()
    .value();
  return ret;
};
